import { useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component

import { FaUser } from "react-icons/fa";
import Modal from "react-modal";
import "./../style/modal.css";
import "./../style/common.css";
import "./../style/pop-up.css";
import { TextField, MenuItem } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { MdGroups } from "react-icons/md";
import { AiOutlineProject } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import { CiWarning } from "react-icons/ci";

const Team = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [project, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [errors, setErrors] = useState({}); //error show state
  const [filteredTeams, setFilteredTeams] = useState([]);
  // State to manage delete team details
  const [deleteTeamName, setDeleteTeamName] = useState("");
  const [deleteTeamId, setDeleteTeamId] = useState(null);
  const [showDeleteTeamBox, setShowDeleteTeamBox] = useState(false);

  const [formData, setFormData] = useState({
    team_project_id: "",
    team_employee_id: "",
    team_name: "",
    team_isactive: true,
  });

  const [editMode, setEditMode] = useState(false); // Edit mode flag

  // Fetch project data from the API
  const fetchProjects = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/projects"
      );
      console.log("response-->", response);
      const projectData = response.data.project.map((pro) => ({
        ProjectId: pro.project_id,
        ProjectName: pro.project_name,
      }));
      console.log("projectData-->", projectData);
      setProjects(projectData);
    } catch (error) {
      console.error("Error fetching project or company data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchProjects();
  }, []);

  // Fetch employees data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/emp"
      );
      const employeeData = response.data.employees
        .map((emp) => ({
          EmployeeId: emp.employee_id,
          EmployeeName: `${emp.employee_first_name} ${emp.employee_last_name}`, // Full name
        }));
      setEmployees(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchTeams = async () => {
    setLoading(true);
    try {
      // Fetch teams, projects, and employees in parallel
      const [response, projectResponse, employeeResponse] = await Promise.all([
        axios.get("/api/teams"),
        axios.get("/api/projects"),
        axios.get("/api/emp")
      ]);

      const teamData = response.data.team.map((t) => ({
        TeamId: t.team_id,
        TeamProjectID: t.team_project_id,
        TeamEmployeeID: t.team_employee_id,
        TeamName: t.team_name,
        TeamIsActive: t.team_isactive,
      }));

      const projectData = projectResponse.data.project;
      const employeeData = employeeResponse.data.employees;

      // Map team data with the corresponding project name and employee name
      const teamsDataWithDetails = teamData.map((team) => {
        // Find the corresponding project
        const project = projectData.find(
          (proj) => proj.project_id === team.TeamProjectID
        );
        // Find the corresponding employee
        const employees = employeeData.find(
          (emp) => emp.employee_id === team.TeamEmployeeID
        );

        return {
          ...team,
          ProjectName: project ? project.project_name : "Unknown Project",
          EmployeeName: employees
            ? `${employees.employee_first_name} ${employees.employee_last_name}`
            : "Unknown Employee",
        };
      });
      setTeams(teamsDataWithDetails);
      setFilteredTeams(teamsDataWithDetails);
    } catch (error) {
      console.error("Error Fetching Team, Project, or Employee Data: ", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTeams();
  }, []);

  //edit
  const handleEdit = (team) => {
    setFormData({
      team_id: team.TeamId,
      team_project_id: team.TeamProjectID,
      team_employee_id: team.TeamEmployeeID,
      team_name: team.TeamName,
      team_isactive: team.TeamIsActive,
    });
    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with pre-filled data
  };

  //delete
  // Handle delete action
  const handleDelete = async (team) => {
    const team_id = team.TeamId;
    const team_name = team.TeamName || "Unnamed Team"; // Replace with actual team name field

    if (!team_id) {
      toast.error("Invalid team ID. Please try again.");
      return;
    }

    // Set the team name and ID to state before showing the pop-up
    setDeleteTeamName(team_name);
    setDeleteTeamId(team_id);
    setShowDeleteTeamBox(true); // Show the custom confirmation box
  };

  // Confirm delete function
  const confirmDeleteTeam = async () => {
    if (!deleteTeamId) return;
    try {
      const response = await axios.delete(
        `/api/team/delete/${deleteTeamId}`
      );
      if (response.status === 200) {
        toast.success("Team deleted successfully!");
        const updatedTeams = teams.filter(
          (item) => item.TeamId !== deleteTeamId
        );
        setTeams(updatedTeams); // Update the teams state after deletion
        setFilteredTeams(updatedTeams); // Update the filtered teams list
      }
      setShowDeleteTeamBox(false); // Close the confirmation box
    } catch (error) {
      console.error("Error deleting Team:", error);
      toast.error("An error occurred while deleting the Team.");
      setShowDeleteTeamBox(false); // Close the box on error
    }
  };

  // Cancel delete function
  const cancelDeleteTeam = () => {
    setShowDeleteTeamBox(false); // Close the confirmation box
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const openModal = (teamData = null) => {
    if (teamData) {
      setFormData({
        team_id: teamData.TeamId,
        team_project_id: teamData.TeamProjectID,
        team_employee_id: teamData.TeamEmployeeID,
        team_name: teamData.TeamName,
        team_isactive: teamData.TeamIsActive,
      });
      setEditMode(true); // Set edit mode
    } else {
      setFormData({
        team_id: "",
        team_project_id: "",
        team_employee_id: "",
        team_name: "",
        team_isactive: true,
      });
      setEditMode(false);
    }
    setIsModalOpen(true);
    setErrors({}); // Reset validation errors
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validateForm = () => {
      const newErrors = {};
      if (!formData.team_name) {
        newErrors.team_name = "Team name is required.";
      } else if (!editMode) {
        // Only check for duplicates in add mode
        const duplicateTeam = teams.find(
          (t) => t.TeamName.toLowerCase() === formData.team_name.toLowerCase()
        );

        if (duplicateTeam) {
          newErrors.team_name = "Team name already exists!";
        }
      }
      if (!formData.team_project_id) {
        newErrors.team_project_id = "Project name is required.";
      }
      if (!formData.team_employee_id) {
        newErrors.team_employee_id = "Team Leader is required.";
      }
      return newErrors;
    };

    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setErrors(errors); // Set errors in state for display
      return; // Stop the submission
    }
    try {
      const url = editMode
        ? `/api/team/update/${formData.team_id}`
        : "/api/team/add";

      const method = editMode ? "put" : "post";

      await axios({
        method,
        url,
        data: formData,
      });
      toast.success(
        editMode ? "Team updated successfully!" : "Team added successfully!"
      );
      fetchTeams(); // Refresh data
      closeModal();
      setErrors({}); // Clear errors after successful submission
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Failed to submit data. Please try again.");
    }
  };

  //Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    { Header: "Team", accessor: "TeamName" },
    {
      Header: "Project",
      accessor: "ProjectName",
      Cell: ({ value }) => (value ? value.toLocaleString() : "N/A"),
    },
    {
      Header: "Team Leader",
      accessor: "EmployeeName",
      Cell: ({ value }) => (value ? value.toLocaleString() : "N/A"),
    },
  ];
  return (
    <div>
      <ToastContainer />
      <div
        v
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <MdGroups /> Team
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>

      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredTeams.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isDeleteAction={true}
          isEditAction={true}
        />
      )}
      {showDeleteTeamBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete the team{" "}
              <span className="team-name">
                <strong>{deleteTeamName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button className="confirm-button" onClick={confirmDeleteTeam}>
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteTeam}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Team Form"
        className="add-team-modal"
        shouldCloseOnOverlayClick={false} //other click on screen, never close form modal
        style={{
          content: {
            width: "450px",
          },
        }}
      >
        <h2>{editMode ? "Edit Team" : "Add Team"}</h2>

        <form
          className="team-form"
          onSubmit={handleSubmit}
          style={{ width: "450px" }}
        >
          <div className="form-container">
            {/* Row 1 */}
            <div className="form-row-team">
              <TextField
                label="Team Name"
                name="team_name"
                value={formData.team_name}
                error={!!errors.team_name}
                helperText={errors.team_name}
                onChange={handleInputChange}
                // disabled={editMode} //Disable when editing
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MdGroups />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                select
                label="Project Name"
                name="team_project_id"
                value={formData.team_project_id}
                error={!!errors.team_project_id}
                helperText={errors.team_project_id}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AiOutlineProject />
                    </InputAdornment>
                  ),
                }}
              >
                <MenuItem value="">Select Project</MenuItem>
                {project.map((project) => (
                  <MenuItem key={project.ProjectId} value={project.ProjectId}>
                    {project.ProjectName}
                  </MenuItem>
                ))}
              </TextField>
                <TextField
                  select
                  label="Team Leader"
                  name="team_employee_id"
                  value={formData.team_employee_id || ""}
                  error={!!errors.team_employee_id}
                  helperText={errors.team_employee_id}
                  onChange={handleInputChange}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                      >
                        <FaUser />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Team Leader</MenuItem>
                  {employees.map((employees) => (
                    <MenuItem
                      key={employees.EmployeeId}
                      value={employees.EmployeeId}
                    >
                      {employees.EmployeeName}
                    </MenuItem>
                  ))}
                </TextField>
            </div>
          </div>
          <div className="all-button-form">
            <button type="submit">{editMode ? "Save" : "+Add"}</button>
            <button type="button" onClick={closeModal} className="close-button">
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Team;
